<template>
    <v-app id="keep">
        <v-progress-circular
                v-if="loadingApp"
                :size="200"
                class="ma-auto"
                color="primary"
                :indeterminate="loadingApp"
                :active="loadingApp"
        ></v-progress-circular>
        <v-app-bar
                v-if="isAuthenticated && !loadingApp"
                app
                clipped-left
                color="light-grey"
        >
            <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
            <span class="title ml-3 mr-5">Outby</span>
            <v-text-field
                    v-if="false"
                    solo-inverted
                    flat
                    hide-details
                    :label="$tc('Search')"
                    prepend-inner-icon="search"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn
                    color="primary"
                    v-if="isAuthenticated"
                    @click="logOutLocal()"
            >
                {{ $tc('LogOut') }}
                <v-icon right>
                    logout
                </v-icon>
            </v-btn>
            <span v-else>{{ $tc('NotLoggedIn') }}</span>
        </v-app-bar>

        <v-navigation-drawer
                v-if="isAuthenticated && !loadingApp"
                v-model="drawer"
                app
                clipped
                color="grey lighten-4"
        >
            <v-select
                    class="ml-3 mr-3 mt-4"
                    :items="areas"
                    :label="$tc('Area')"
                    :item-text="'name'"
                    :item-value="'pk'"
                    :loading="areaSelectIsLoading"
                    v-model="selectedAreaPkForVModel"
                    v-on:change="setArea()"
                    outlined
                    dense
            ></v-select>

            <v-list
                    dense
                    class="grey lighten-4"
            >
                <template v-for="(item, i) in menuChoices">
                    <v-list-group
                            v-if="item.sub_choices"
                            :key="i"
                            :prepend-icon="item.icon"
                            :value="false"
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item
                                v-for="(sub_choice, x) in item.sub_choices"
                                :key="x"
                                link
                                :to="sub_choice.link"
                        >
                            <v-list-item-action>
                                <v-icon>{{ sub_choice.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                        {{ sub_choice.text }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                    <v-divider
                            v-else-if="item.divider"
                            :key="i"
                            dark
                            class="my-4"
                    ></v-divider>
                    <v-list-item
                            v-else-if="shouldShowMenuItem(item.onlySuperUsers)"
                            :key="i"
                            link
                            :to="item.link"
                    >

                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                    {{ item.text }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>

            <v-divider
                    dark
                    class="my-4"
            ></v-divider>

<!--            <v-switch-->
<!--                    class="ml-3 mr-5"-->
<!--                    v-model="show_including_vat"-->
<!--                    label="Inkludera moms">-->
<!--            </v-switch>-->

        </v-navigation-drawer>

        <v-content v-if="!loadingApp">
            <v-container>
                <router-view></router-view>
            </v-container>
        </v-content>

        <v-snackbar
                v-model="connectionFailureMessageSnackBar"
                :timeout="timeout"
                color="warning"
        >
            <v-row>
                <v-icon
                        color="white"
                >
                    error
                </v-icon>
                <span class="ml-1">
                        {{ $tc('NoConnectionToServer') }}.
                    </span>
            </v-row>
        </v-snackbar>

        <v-footer app v-if="!loadingApp">
        </v-footer>
    </v-app>
</template>

<script>
    import i18n from "@/i18n";
    import {mapGetters, mapMutations, mapState} from 'vuex';
    import axios from "axios";
    import {DISCOUNT_CODES, EXPORT, PAYMENTS, CUSTOM_PERIOD, BUY, INTERNAL_STATISTICS} from "@/router/router_constants";

    export default {
        props: {
            source: String,
        },
        data: () => ({
            timeout: 0,
            areaSelectIsLoading: true,
            drawer: null,
            menuChoices: [
                {icon: 'home', text: i18n.tc('Home', 1), link: '/', onlySuperUsers: false},
                {icon: 'add_shopping_cart', text: i18n.tc('RegisterTicket', 3), link: BUY, onlySuperUsers: true},
                {
                    icon: 'bar_chart',
                    text: i18n.tc('Statistics', 1),
                    link: '/',
                    sub_choices: [
                        // {text: i18n.tc('DayView', 1), link: '/day_view'},
                        // {text: i18n.tc('WeekView', 1), link: '/week_view'},
                        // {text: i18n.tc('MonthView', 1), link: '/month_view'},
                        // {text: i18n.tc('YearView', 1), link: '/year_view'},
                        {text: i18n.tc('CustomPeriod', 1), link: CUSTOM_PERIOD},
                    ],
                    onlySuperUsers: false,
                },
                // {icon: 'receipt', text: i18n.tc('TicketType', 2), link: '/ticket_types'},
                {
                    icon: 'card_giftcard',
                    text: i18n.tc('Discount', 3),
                    sub_choices: [
                        {text: i18n.tc('DiscountCode', 3), link: DISCOUNT_CODES},
                    ],
                    onlySuperUsers: true,
                },
                {icon: 'payment', text: i18n.tc('Payment', 3), link: PAYMENTS, onlySuperUsers: false,},
                {icon: 'get_app', text: i18n.tc('Export', 1), link: EXPORT, onlySuperUsers: false,},
                // {icon: 'archive', text: i18n.tc('Accounting', 1), link: '/accounting' onlySuperUsers: false,},
                {divider: true},
                {icon: 'bar_chart', text: i18n.t('InternalStatistics'), link: INTERNAL_STATISTICS, onlySuperUsers: true,},
                // {icon: 'settings', text: i18n.tc('Setting', 2), link: '/settings', onlySuperUsers: true,},
            ],
            areas: [],
        }),
        computed: {
            // localComputed () { /* ... */ },
            // mix this into the outer object with the object spread operator
            ...mapState('auth', [
                'error',
                'loadingApp',
                'userIsSuperUser',
            ]),
            ...mapState('common', [
                'lastAttemptToReachServerFailed',
                'selectedArea',
                'selectedAreaPk',
            ]),
            // We must have a local property ith getter and setter
            // since Vuex does not allow setting state directly (mutations must be used)
            selectedAreaPkForVModel: {
                get: function () {
                    return this.selectedAreaPk;
                },
                set: function (newValue) {
                    this.setSelectedAreaPk(newValue);
                }
            },
            ...mapGetters('auth', [
                'isAuthenticated',
            ]),
            ...mapGetters('common', [
                'serverURL',
                'serverURLNoPath',
            ]),
            connectionFailureMessageSnackBar: {
                get() {
                    return this.$store.state.common.lastAttemptToReachServerFailed;
                },
            },
        },
        methods: {
            logOutLocal() {
                axios
                    .post(this.serverURLNoPath + '/accounts/logout/')
                    .then(response => {
                        if (response.status != 200) {
                            console.log('Failed to log out');
                        } else {
                            this.$store.commit('common/resetCommonStorageOnLogout')
                            this.logOut()
                            this.$router.push({name: 'Login'})
                        }
                    });
            },
            setArea() {
                axios
                    .put(this.serverURL + '/set_selected_area/'
                        , {'area_pk': this.selectedAreaPk}
                    )
                    .then(() => {
                        let newArea = this.areas.find(area => area.pk == this.selectedAreaPk);
                        this.setSelectedArea(newArea);
                        this.loadAllData();
                    })
                    .catch(() => {
                        // Return to previous selection
                        this.setSelectedAreaPk(this.selectedArea.pk);
                    });
            },
            loadAllData() {
                if (this.isAuthenticated) {
                    axios
                        .get(this.serverURL + '/get_areas_for_user/')
                        .then(response => {
                            this.areas = response.data;

                            let newArea = this.areas.find(area => area.is_selected);
                            let newAreaPk = newArea.pk;

                            this.setSelectedArea(newArea);
                            this.setSelectedAreaPk(newAreaPk);

                            this.areaSelectIsLoading = false;
                        })
                }
            },
            // Checks if a menu item should be hidden for non super users
            shouldShowMenuItem(onlySuperUsersMenuItemSetting) {
                return !onlySuperUsersMenuItemSetting || this.userIsSuperUser;
            },
            ...mapMutations({
                logOut: 'auth/logOut',
                resetCommonStorageOnLogout: 'common/resetCommonStorageOnLogout',
                setSelectedArea: 'common/setSelectedArea',
                setSelectedAreaPk: 'common/setSelectedAreaPk',
            }),
        },
        watch: {
            isAuthenticated() {
                this.loadAllData();
            }
        },
        mounted() {
            this.loadAllData();
        },
    }
</script>

<style>
    #keep .v-navigation-drawer__border {
        display: none
    }
</style>